"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStrategyPreviewContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledStrategyPreviewContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  overflow: hidden;

  .strategy-preview-skeleton {
    gap: 0;
    flex: 1;

    span {
      transform: scale(1, 0.6);

      &:nth-child(9),
      &:nth-child(10),
      &:nth-child(11),
      &:nth-child(12) {
        display: none;
      }
    }
  }
`;
